import { render, staticRenderFns } from "./AuctionProtocol.vue?vue&type=template&id=4fc51018&scoped=true&"
var script = {}
import style0 from "./AuctionProtocol.vue?vue&type=style&index=0&id=4fc51018&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc51018",
  null
  
)

export default component.exports